import { useEffect, useState } from "react";
import axios from "axios";
import { getDownloadURL, ref } from "firebase/storage";
import { profileStorage } from "../store/firebase-config";
import { isEmpty } from "lodash";

export default function useGetUserProfileImage(entry) {
  const [profilePicture, setProfilePicture] = useState("");

  const pathReference = ref(profileStorage, entry?.uid);
  useEffect(() => {
    if (!isEmpty(entry?.uid)) {
      getDownloadURL(pathReference)
        .then((url) => {
          setProfilePicture(url);
        })
        .catch((error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case "storage/object-not-found":
              // File doesn't exist
              setProfilePicture("");

              break;
            case "storage/unauthorized":
              // User doesn't have permission to access the object
              setProfilePicture("");

              break;
            case "storage/canceled":
              // User canceled the upload
              setProfilePicture("");

              break;
            case "storage/unknown":
              // Unknown error occurred, inspect the server response
              setProfilePicture("");
              break;
          }
        });
    }
  }, [entry]);

  return { profilePicture };
}
